import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBirthChartsDataContext } from './hooks/useBirthChartsDataContext';

export const TypeOfBirth = () => {
    const { chartData } = useBirthChartsDataContext();


    return (
        <SimpleBars
            title={'Tipo de Parto'}
            horizontal={false}
            subtitles={chartData?.typeOfBirth?.map((item) => item.description)}
            values={chartData?.typeOfBirth?.map((item) => item.total  ||  0)}
        />
    );
};
